var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-mappy',{attrs:{"loading":_vm.loading},on:{"stop-loading":function($event){_vm.loading=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }